<div class="dialog-header">
	<div class="header-title"><span style="font-size: 120%;">Create Invoice</span></div>

	<button mat-button class="close-button-container" mat-dialog-close disableRipple="true">
		<mat-icon>clear</mat-icon>
	</button>
</div>
<div class="crtest-content">
	<div class="radio-block">
		<div class="radio-button" *ngFor="let rb of values">
			<p-radioButton name="group1" value="{{rb.value}}" label="{{rb.label}}" [(ngModel)]="val1"
				(onClick)="radioChanged(rb.percent)" inputId="{{rb.opt}}"></p-radioButton>

			<div class="custom-field" *ngIf="rb.label === 'Custom'">
				<p-inputNumber #tagAmount [(ngModel)]="inputAmount" prefix="%" [disabled]="val1 !== 'Custom'" [min]="0"
					[max]="101">
				</p-inputNumber>
			</div>
		</div>
	</div>
	<div class="save-btn-block">
		<button mat-button class="save-btn" (click)="createEstInv()" [disabled]="loadingSpinner || !val1" tabindex="1"
			type="submit" [ngClass]="{'disabled-button': loadingSpinner || !val1}">

			<span *ngIf="!loadingSpinner">Create Invoice</span>
			<lib-mini-progress-spinner *ngIf="loadingSpinner"></lib-mini-progress-spinner>
		</button>
	</div>
</div>